// extracted by css-extract-rspack-plugin
export default {"wrap":"MailboxContentPreview_wrap__DCfmL","content":"MailboxContentPreview_content__RpLVd","blueAction":"MailboxContentPreview_blueAction__O8m0M"};